export interface Point {
  x: number;
  y: number;
}

export function pointToString(point: Point): string {
  return `${point.x},${point.y}`;
}

/**
 * Calculates the midpoint between two points.
 *
 * @param pt1 - The first point.
 * @param pt2 - The second point.
 * @returns The midpoint between the two points.
 */
export function midPoint(pt1: Point, pt2: Point): Point {
  return {
    x: (pt2.x + pt1.x) / 2,
    y: (pt2.y + pt1.y) / 2,
  };
}

export type Angle = number;
